import {Autocomplete, TextField, useTheme} from "@mui/material";
import {observer} from "mobx-react";
import FormFieldBase from "./FormFieldBase";
import React from "react";

function FormAutocompleteField({
                                   label, field, options, readOnly = false,
                                   form,
                                   fieldName,
                                   updateValue = async (event, newValue) => {
                                       if (form) {
                                           await form.updateFieldWithValue(fieldName, newValue.value)
                                       } else {
                                           field.updateValue(newValue.value)
                                       }
                                   },
                                   selectedValue = async (event, newValue) => {
                                       if (form) {
                                           await form.updateFieldWithValue(fieldName, newValue)
                                       } else {
                                           field.selectedValue(newValue)
                                       }
                                   },
                                   save = (event, newValue) => {},
                                   clear = undefined,
                                   allowFreeText = false,
                               }) {
    const theme = useTheme();

    function sortedOptions() {
        let sortedOptions = options.slice().sort(((option, anotherOption) => option.label.charAt(0).localeCompare(anotherOption.label.charAt(0))))
        return sortedOptions.map((option) => {
            return {label: option.label, value: option.value}
        });
    }

    const optionFor = (value) => sortedOptions().find(o => o.value === value);
    const getOptionFromValue = (value) => {
        if (typeof value === 'string') {
            return optionFor(value)?.label || value;
        }
        return value?.label || "";
    };

    const formField = form ? form.getFieldByName(fieldName) : field;
    const value = getOptionFromValue(formField.value);
    const readonly = form ? (readOnly || form.isReadonly(fieldName)) : readOnly;

    return (
        <FormFieldBase>
            <Autocomplete
                freeSolo
                disablePortal
                id={label}
                style={{
                    backgroundColor: theme.brand.field,
                    borderRadius: '5px',
                }}
                fullWidth
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={readonly}
                onChange={(event, newValue, reason) => {
                    if (reason === 'selectOption') {
                        selectedValue(event, newValue.value);
                        save(newValue.value);
                    }
                    if (reason === 'clear') {
                        if (clear) {
                            clear()
                        } else {
                            selectedValue(event, '');
                            save('');
                        }
                    }
                }
                }
                value={value}
                inputValue={value}
                renderInput={(params) => {
                    return <TextField {...params} label={label}
                                      onChange={(event) => formField.updateValue(event.target.value)}
                                      onBlur={(event) => allowFreeText && updateValue(event, {value: event.target.value})}
                                      required={!formField.isOptional}
                                      error={!readonly && formField.hasValue && !formField.isValid}
                                      InputProps={{
                                          ...params.InputProps,
                                      }}
                                      sx={{
                                          '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root, & .MuiInputBase-input': {
                                              fontSize: '.8rem',
                                          },
                                      }}
                    />
                }
                }
                options={sortedOptions()}
            />
        </FormFieldBase>
    );

}

export default observer(FormAutocompleteField);